var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"solutions"},[_c('solutions-component',{attrs:{"solution-data":_vm.data,"solution-menu":_vm.otherSolutions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }